import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/nirAccomplishment/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/nirAccomplishment/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/nirAccomplishment', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/nirAccomplishment', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/nirAccomplishment/' + id)
  }
}
